/* eslint-disable no-nested-ternary */
import HeadingWithShowAll from 'Components/globalSearch/components/HeadingWithShowAll';
import DrawerAlerts from 'Components/alerts/components/DrawerAlerts';
import AccountPopOver from 'Components/common/components/AccountPopOver';
import DrawerUploadDocument from 'Components/document/DrawerUploadDocument';
import GlobalSearch from 'Components/globalSearch/components/GlobalSearch';
import DocumentSvg from 'Components/layout/assets/DocumentSvg';
import NavBarPrimary, { chatActions, chatStates } from 'Components/layout/headers/NavBarPrimary';
import {
  SlicerResultPage,
  IsTablet,
  MidWidthApp1200,
  getCurrentTime, getTimezoneInGMT, isEnterpriseUser,
  scrollHandlerToggleClass, valueToObject,
} from 'Utils/UtilityFunctions';
import {
  CANCEL_FAILED_TOASTER,
  CANCEL_UPLOAD_POPUP,
  DOCUMENT_DOWNLOAD_FAIL, DOCUMENT_DOWNLOAD_SUCCESS, FEED_GILROY_ROUTE,
  SEARCH_ROUTE,
  SMART_REDIRECTION_TEXT,
} from 'Utils/Constants';
import {
  maxMobile, maxTablet, maxWidth,
  midWidthApp,
  minExtraLargeScreen,
  primaryFont,
  primaryHeadingColor,
  retina,
  scrollbar,
  secondaryFont,
  textBlack,
  wMBold,
  wMLight,
  sadGilroyFace,
} from 'Utils/utilsStyle';
import React, {
  useEffect, useState,
} from 'react';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectBatchSize,
  selectBatchUploading,
  selectCancelPopup,
  selectCompanyId,
  selectCurrentFolder,
  selectCurrentHubView,
  selectDeleteId,
  selectDeletePopupType,
  selectDeletePopupVisible,
  selectDownloadUrl,
  selectDrawerOpen,
  selectDrawerState,
  selectEntities,
  selectEntitiesEnded,
  selectEntitiesLoaded,
  selectEntitiesLoading,
  selectFailedDocuments,
  selectFileViewURL,
  selectIsAdmin,
  selectIsSelectAll,
  selectNextUploadDocuments,
  selectRenameData,
  selectSapSelectedDocOffset,
  selectSearchTerm,
  selectSelectedDocuments,
  selectSelectedDocumentsCount,
  selectShowSelected,
  selectSortFlurry, selectSuccessDocuments,
  selectUnselectedDocuments, selectUploadCancelled,
  selectUploadDocumentStatus,
  selectUploadDocuments,
  selectUploadedByMe,
  selectUploadedDocuments,
  selectValidateLoading,
  selectdocHubSort,
} from 'Selector/DocumentHubSelector';
import EmptyStateDocumentHub from 'Components/document/EmptyStateDocumentHub';
import { actions } from 'Slice/DocumentHubSlice';
import { actions as flurryActions } from 'Slice/HelperSlice';
import { actions as globalSearchContentActions } from 'Slice/GlobalSearchContentSlice';
import {
  selectLoaded,
  selectShowChatbot, selectShowDocumentHub,
  selectShowGlobalGilroy, selectShowUploadDocument,
} from 'Selector/GlobalSearchContentSelector';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import {
  Divider, Modal, Tooltip, notification,
} from 'antd';
import BackIcon from 'Components/common/assets/svgIcons/BackIcon';
import classNames from 'classnames';
import UploadDocumentIcon from 'Components/common/assets/svgIcons/UploadDocumentIcon';
import {
  DocHubCurrentViewType, DocHubEntity,
} from 'Types/DocumentHubTypes';
import DocumentUploadCancelPopup from 'Components/common/modal/DocumentUploadCancelPopup';
import { actions as UiAction } from 'Slice/UISlice';
import { actions as certificationActions } from 'Slice/CertificationSlice';
import { actions as companyActions } from 'Slice/CompaniesSlice';
import {
  selectActivetype, selectAiCertificationData, selectHighlight,
  selectIsCompletionPopupOpen, selectIsHighlighted, selectIsScroll,
} from 'Selector/CertificationSelector';
import DrawerPeopleGroup from 'Components/people/components/DrawerPeopleGroup';
import { selectIsPagination } from 'Selector/GlobalSearchResultsSelector';
import DocumentHubTableSkeleton from 'Components/common/skeleton/DocumentHubTableSkeleton';
import SectionHeading from 'Components/globalSearch/components/SectionHeading';
import { SearchResultsRouteState } from 'Pages/search/GlobalSearchResults';
import AddItemToFolderModal from 'Components/common/modal/AddItemToFolderModal';
import { Gilroy } from 'gilroy-global';
import { useGilroy } from 'Utils/hooks/useGilroy';
import DocumentHubTable from './DocumentHubTable';
import DocumentHubHeader from './DocumentHubHeader';

const Wrapper = styled.div`
&.documentHubInSAP {
  .container {
    padding: 0px;
    @media all and (min-width: 1280px) {
      width: 100%;
    }
    .sub-container-document-hub {
      margin-top: 34px;    
    }
    .empty-state-document-hub-wrapper {
      height: calc(-469px + 100vh);
      @media all and (max-width: ${maxWidth}), ${retina} {
        height: calc(-455px + 100vh);
      }
      @media all and (max-width: ${maxTablet}) {
        height: calc(-500px + 100vh);
      }
      ${scrollbar};
      padding: 20px 0;
      .empty-document-img {
        width: 330px;
        height: 190px;
        @media all and (max-width: ${maxWidth}), ${retina} {
          width: 260px;
          height: 140px;
        }
      }
      .empty-heading {
        margin-top: 13px;
        font-size: 16px;
        line-height: 18px;
        &.second, &.green-text {
          margin-top: 0px;
        }
      }
    }
    .withCheckboxWrapper {
      .table-item {
        &:first-child {
          min-width: 44px !important;
          max-width: 44px !important;
        }
          &:nth-child(2) {
          min-width: 175px !important;
          max-width: 175px !important;
        }
          &:nth-child(3), &:nth-child(4) {
          min-width: 115px !important;
          max-width: 115px !important;
        }
        &:nth-child(5), &:nth-child(6) {
          display: none;
        }
      }
      .document-hub-inner-style-wrapper {
        .table-width-decide {
          @media all and (max-width: ${midWidthApp}) {
            min-width: fit-content;
          }
          .header-table {
            padding: 0px 6px 0px 4px;
            .table-item {
              padding: 10px 0px;
              padding-top: 15px;
              &:first-child {
                padding-top: 10px;
              }
              &:nth-child(2) {
                padding-left: 39px;
              }
              .ant-checkbox-wrapper {
                margin-left: 13px;
              }
              .heading-div {
                .heading-text {
                  font-size: 14px;
                }
                .action-div {
                  .down-angle-icon {
                    width: 7px;
                    height: 7px;
                  }
                }
              }
            }
          }
          .infinite-scroll-component__outerdiv {
            .infinite-scroll-component {
              &.loaderDrawer {
                width: 100%;
              }
              padding: 5px 5px 5px 1px;
              height: calc(100vh - 565px) !important;
              min-height: calc(100vh - 565px);
              overflow: hidden auto !important;
              width: fit-content;
              ${scrollbar};
              @media all and (max-width: ${maxWidth}), ${retina} {
                height: calc(100vh - 511px) !important;
                min-height: calc(100vh - 511px);
              }
              @media all and (max-width: ${maxTablet}) {
                height: calc(100vh - 575px) !important;
                min-height: calc(100vh - 575px);
              }
              .document-hub-table-skelton-wrapper {
                padding: 0px 2px;
                width: 100%;
                .document-detail-skeleton-wrapper {
                  padding: 16px 12px;
                  .skeleton-box {
                    &:nth-child(2) {
                      width: 130px;
                      min-width: 130px;
                    }
                    &:nth-child(3),:nth-child(4) {
                      display: none !important;
                    }
                  }
                }
              }
              .body-table {
                min-height: 80px;
                box-shadow: rgba(0, 0, 0, 0.03) 0px 0px 24px;
                .table-item {
                  .ant-checkbox-wrapper {
                    margin-left: 11px;
                  }
                  .table-item-file-name {
                    .file-img {
                      width: 30px;
                      min-width: 30px;
                      height: 32px;
                      margin-right: 8px;
                    }
                    .ant-badge-dot {
                      width: 10px;
                      height: 10px;
                      left: 20px;
                    }
                    .file-name-desktop {
                      font-size: 16px;
                    }
                    .file-size-folder-div {
                      .text-date {
                        &.fileSize {
                          display: none;
                        }
                      }
                      .ant-divider {
                        display: none;
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
&.globalSearchFlag {
  .document-hub-table-skelton-wrapper {
      padding: 0px 3px 16px 3px !important;
  }
}
.header-main-wrapper {
  .left-side-wrap {
    .ant-divider {
      color: #ddd;
      height: 28px;
    }
    .heading {
      border-left: 0px;
      padding-left: 0px;
    }
  }
}
&.ShowBackBtnStyle {
  .back-action-div {
    margin: 16px 0px;
    @media all and (max-width: ${maxWidth}), ${retina} {
      margin: 14px 0px;
    }
  }
  .sub-container-document-hub {
    margin-top: 0px;
  }
}
.sub-container-document-hub {
  &.sticky-header-document {  
    .container-heading-div {
      position: sticky;
      top: 80px;
      background-color: #fff;
      z-index: 1;
      border-top-left-radius: 13px;
      border-top-right-radius: 13px;
      border: 1px solid #DADADA;
      border-bottom: 0px;
    }
   .header-table {
    &.folderViewHeaderTable {
      top: 178px;
    }
      position: sticky;
      top: 168px;
      background-color: #fff;
      padding: 6px 30px;
      z-index: 1;
      border: 1px solid #DADADA;
      border-top: 0px;
    }
  }
    background-color: #fff;
    border-radius: 16px;
    height: calc(100% - 130px);
    margin-top: 32px;
  }
  .container {
    &.bottomAccordion {
      .chatbot-v2 {
        margin-bottom: 200px;
      }
    }
    .chatbot-v2 {
      margin-top: 48px;
      @media all and (max-width: ${maxWidth}), ${retina} {
        margin-bottom: 0px;
      }
      &.chatbot-container {
        padding-bottom: 5px;
        @media all and (max-width: ${maxTablet}) {
          padding-bottom: 20px;
        }
        .boxDoor {
          @media all and (max-width: ${maxTablet}) {
            display: none;
          }
        }
      }
    }
  }
  .searchDocumentContainer {
    .sub-container-document-hub {
      margin-top: 0px;
      background: transparent;
      .right-side {
        margin-top: 0px;
      }
      .document-hub-inner-style-wrapper {
        .table-width-decide {
         .table-item {
          &:first-child {
            min-width: 500px !important;
            max-width: 500px !important;
            .file-name-desktop {
             font-size: 18px !important;
            }
          }
        }
      } 
    }
    .withCheckboxWrapper {
      padding: 0px;
      .document-hub-inner-style-wrapper {
        padding: 0px;
        .table-width-decide {
          .infinite-scroll-component__outerdiv {
            .infinite-scroll-component{
              padding:0px 0px;
              min-height: auto;
              .body-table{
                .file-name-desktop {
                  color: ${textBlack};
                  font-family: ${primaryFont};
                  font-size: 18px;
                  font-weight: ${wMLight};
                  line-height: 20px;
                  letter-spacing: -0.7px;
                  @media all and (min-width: ${minExtraLargeScreen}) {
                    font-size: 26px;
                    line-height: 28px;
                    letter-spacing: -1.005px;
                  }
                }
                .file-name {
                  color: ${textBlack};
                  font-family: ${primaryFont};
                  font-size: 18px;
                  font-weight: ${wMLight};
                  line-height: 20px;
                  letter-spacing: -0.7px;
                  @media all and (max-width: ${maxTablet}) {
                    font-size: 16px;
                    line-height: 18px;
                    letter-spacing: -0.548px;
                  }
                  @media all and (max-width: ${maxMobile}) {
                    font-size: 12px;
                    line-height: 11.913px;
                    letter-spacing: -0.207px;
                    max-width: 150px;
                  }
                }
              }
            }
          }
        }
      } 
    }
    
  }
`;

const BackActionDiv = styled.div`
display: flex;
align-items: center;
.back-icon-svg {
  width: 17px;
  min-width: 17px;
  height: 17px;
  @media all and (max-width: ${maxWidth}), ${retina} {
    width: 15px;
    min-width: 15px;
    height: 15px;
    min-height: 16px;
  }
}
.ant-divider-vertical {
  border-left: 1px solid #DDD;
}
.back-action-text {
  font-family: ${secondaryFont};
  font-size: 16px;
  font-weight: ${wMBold};
  line-height: 32px;
  letter-spacing: -0.625px;
  color: #667982;
  @media all and (max-width: ${maxWidth}), ${retina} {
    font-size: 14px;
    line-height: 20px;
  }
}
`;

type Props = {
  heading?: string,
  count?: number,
  documentsCount?: DocHubEntity[],
  inSmartDrawer?: boolean,
  inGlobalSearch?: boolean,
  documentsToDisplay?: DocHubEntity[]
  globalSearchloading?: boolean
  searchQuery?: string
} & typeof defaultProps;

const defaultProps = {
  heading: '',
  count: 0,
  documentsCount: [] as DocHubEntity[],
  inSmartDrawer: false,
  inGlobalSearch: false,
  documentsToDisplay: [] as DocHubEntity[],
  globalSearchloading: false,
  searchQuery: '',
};

const DocumentHub = function DocumentHub(props: Props) {
  const { gilroyStates, gilroyActions } = useGilroy();
  const [searchParams] = useSearchParams();
  const extendedSections = ['person', 'company', 'article', 'industry', 'group', 'document'];
  const extendedSection = (searchParams.get('extend') ?? '');
  const slicerNumber: number = SlicerResultPage();
  const isDetailedSearch: boolean = extendedSections.includes(extendedSection);
  const {
    inSmartDrawer, inGlobalSearch, documentsToDisplay, heading, count,
    documentsCount, globalSearchloading, searchQuery,
  } = props;
  const [openCreateModal, setOpenCreateModal] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const isTab = IsTablet();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { saveUrl: saveUrlV2, saveProfileName: saveProfileNameV2 } = chatStates;
  const startTime = getCurrentTime();
  const isMidWidth = MidWidthApp1200();
  const docHubSort = useSelector(selectdocHubSort);

  const entities = useSelector(selectEntities);
  const entitiesLoading = useSelector(selectEntitiesLoading);
  const entitiesLoaded = useSelector(selectEntitiesLoaded);
  const entitiesEnded = useSelector(selectEntitiesEnded);
  const currentFolder = useSelector(selectCurrentFolder);
  const drawerOpen = useSelector(selectDrawerOpen);
  const batchUploading = useSelector(selectBatchUploading);
  const downloadUrl = useSelector(selectDownloadUrl);
  const showDocumentHub = useSelector(selectShowDocumentHub);
  // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
  const uploadedByMe = useSelector(selectUploadedByMe);
  const drawerState = useSelector(selectDrawerState);
  const searchTerm = useSelector(selectSearchTerm);
  const uploadCancelled = useSelector(selectUploadCancelled);
  const successDocuments = useSelector(selectSuccessDocuments);
  const uploadDocuments = useSelector(selectUploadDocuments);
  const nextUploadDocuments = useSelector(selectNextUploadDocuments);
  const isEnterprise = isEnterpriseUser();
  const timezone = getTimezoneInGMT();
  const [uploadedDocCount, setUploadedDocCount] = useState(0);
  const { okButtonText, cancelButtonText, popupText } = useSelector(selectCancelPopup);
  const deletePopupVisible = useSelector(selectDeletePopupVisible);
  const deletePopupType = useSelector(selectDeletePopupType);
  const deleteId = useSelector(selectDeleteId);
  const failedDocument = useSelector(selectFailedDocuments);
  const chatbotAllowed = useSelector(selectShowChatbot);
  const companyId = useSelector(selectCompanyId);
  const allowGlobalGilroy = useSelector(selectShowGlobalGilroy);
  const aiCertificationData = useSelector(selectAiCertificationData);
  const previewDocument = useSelector(selectFileViewURL);
  const isCompletionPopupOpen = useSelector(selectIsCompletionPopupOpen);
  const currentType = useSelector(selectActivetype);
  const isScroll = useSelector(selectIsScroll);
  const isHighlight = useSelector(selectHighlight);
  const isHighlighted = useSelector(selectIsHighlighted);
  const sortFlurry = useSelector(selectSortFlurry);
  const isAdmin = useSelector(selectIsAdmin);

  const isSelectAll = useSelector(selectIsSelectAll);
  const selectedDocuments = useSelector(selectSelectedDocuments);
  const unSelectedDocuments = useSelector(selectUnselectedDocuments);
  const showSelected = useSelector(selectShowSelected);
  const sapSelectedDocOffset = useSelector(selectSapSelectedDocOffset);
  const globalSearchContentLoaded = useSelector(selectLoaded);
  const isDocumentSearchPaginated: boolean = useSelector(selectIsPagination);
  const searchDocumentHubVisible = inGlobalSearch && documentsToDisplay;
  const currentView = useSelector(selectCurrentHubView);
  const uploadedDocs = useSelector(selectUploadedDocuments);
  const renameData = useSelector(selectRenameData);
  const uploadedDocuments = currentView === 'document' ? uploadedDocs : [];

  const host = window.location.href;
  const location = useLocation();
  const { state } = location as { state: SearchResultsRouteState };
  const previousPath = (state)?.previousPath ?? FEED_GILROY_ROUTE;

  const selectedDocumentsString = selectedDocuments.filter((d) => d.type === 'document').map((d) => d.id).join(',');
  const unSelectedDocumentsString = unSelectedDocuments?.filter((d) => d.type === 'document').map((d) => d.id).join(',');
  const selectedFoldersString = selectedDocuments.filter((d) => d.type === 'folder').map((d) => d.id).join(',');
  const unSelectedFoldersString = unSelectedDocuments.filter((d) => d.type === 'folder').map((d) => d.id).join(',');
  const selectedDocumentsCount = useSelector(selectSelectedDocumentsCount);
  const uploadDocumentStatus = useSelector(selectUploadDocumentStatus);
  const ValidateLoading = useSelector(selectValidateLoading);
  const { pathname } = useLocation();
  const isFolderSelected = !currentFolder && (isSelectAll || selectedFoldersString.length > 0);
  const deletePopupText = () => {
    if (currentFolder?.id) {
      if (deleteId) {
        return 'Are you sure you want to remove this document?';
      }

      return 'Are you sure you want to remove the selected document(s)?';
    }

    if (searchTerm.length) {
      return 'Are you sure you want to remove the selected item(s)?';
    }

    return 'Deleting the folder(s) will permanently delete all of its contents.\nDo you want to proceed ?';
  };

  const redirectFrom = () => {
    if (saveProfileNameV2 && !saveProfileNameV2.includes(SMART_REDIRECTION_TEXT)) {
      return 'gilroy';
    }
    if (inSmartDrawer) {
      return 'smartAccountPlan';
    }
    return 'docHub';
  };
  const showUploadDocument = useSelector(selectShowUploadDocument);

  const [drawerOpenForDoc, setDrawerOpenForDoc] = useState(false);

  useEffect(() => {
    if (popupText) {
      dispatch(flurryActions.callFlurryEvent(valueToObject('documentHub_upload_cancel_intent', 0, {
        host,
      })));
    }
  }, [popupText]);

  useEffect(() => {
    dispatch(actions.setInSap(inSmartDrawer));
    return () => {
      dispatch(actions.setInSap(inSmartDrawer));
    };
  }, [inSmartDrawer]);

  useEffect(() => {
    dispatch(actions.setPreviewDrawerOpen(drawerOpenForDoc));
  }, [drawerOpenForDoc]);

  useEffect(() => {
    if (!batchUploading && uploadCancelled && !inSmartDrawer) {
      notification.destroy();
      successDocuments.forEach((doc) => {
        dispatch(actions.deleteDocument({
          selectedDocuments: doc.id?.toString(),
          unSelectedDocuments: '',
          isSelectAll: false,
          uploadedByMe: 'false',
        }));
      });
      dispatch(actions.resetBatch());
      dispatch(actions.resetUploadCancel());
    }
  }, [batchUploading, uploadCancelled]);

  useEffect(() => {
    if (!inSmartDrawer) {
      if (!uploadDocuments?.length && successDocuments?.length && !uploadCancelled) {
        if (saveProfileNameV2?.includes(SMART_REDIRECTION_TEXT)) {
          setUploadedDocCount(uploadedDocCount + (successDocuments?.length ?? 0));
        }
        if (successDocuments.some((successDoc) => successDoc.isLink === true)) {
          dispatch(flurryActions.callFlurryEvent(valueToObject('documentHub_link_upload_successful', 0, {
            file_type: successDocuments.map((fileType) => fileType.extension).join(',').toString(),
            redirection_from: redirectFrom(),
            host,
          })));
        } else {
          dispatch(flurryActions.callFlurryEvent(valueToObject('documentHub_uploadDocument_successful', 0, {
            file_type: successDocuments.map((fileType) => fileType.extension).join(',').toString(),
            redirection_from: redirectFrom(),
            host,
          })));
        }
      }
      if (!uploadDocuments?.length && failedDocument?.length && !uploadCancelled) {
        if (failedDocument.some((successDoc) => successDoc.isLink === true)) {
          dispatch(flurryActions.callFlurryEvent(valueToObject('documentHub_link_upload_failure', 0, {
            file_type: failedDocument.map((fileType) => fileType.type).join(',').toString(),
            redirection_from: redirectFrom(),
            host,
          })));
        } else {
          dispatch(flurryActions.callFlurryEvent(valueToObject('documentHub_uploadDocument_failure', 0, {
            file_type: failedDocument.map((fileType) => fileType.type).join(',').toString(),
            redirection_from: redirectFrom(),
            host,
          })));
        }
      }
    }
  }, [uploadDocuments]);

  useEffect(() => {
    if (drawerOpen && !currentFolder?.id) {
      setTimeout(() => {
        dispatch(actions.setFoldersPopupType('upload'));
        dispatch(actions.toggleFoldersPopup(true));
      }, 200);
    }
  }, [drawerOpen]);

  const toggleDrawer = () => {
    if (drawerOpen && ((batchUploading && !uploadCancelled)
      || (uploadCancelled && nextUploadDocuments?.length))) {
      dispatch(actions.setCancelPopup({
        popupText: CANCEL_UPLOAD_POPUP,
        okButtonText: 'Yes',
        cancelButtonText: 'No',
      }));
    } else {
      dispatch(actions.setDrawerOpen(!drawerOpen));
      if (isHighlight && currentType === 'document_hub_panel') {
        dispatch(certificationActions.setHighlight(false));
        dispatch(certificationActions.setIsHighlighted(true));
      }
    }
  };

  const handleUploadClick = () => {
    toggleDrawer();
    if (!drawerOpen) {
      dispatch(flurryActions.callFlurryEvent(valueToObject('documentHub_upload_intent', 0, {
        redirection_from: redirectFrom(),
        host,
      })));
    }
  };

  const handleDrawerState = (value: string) => {
    dispatch(actions.setDrawerState(value));
  };

  useEffect(() => {
    const node = document.querySelector('body');
    return drawerOpen ? node?.classList.add('body-drawer-toggle') : node?.classList.remove('body-drawer-toggle');
  }, [drawerOpen]);

  useEffect(() => {
    if (!isHighlighted && !isScroll && currentType === 'document_hub_panel') {
      dispatch(certificationActions.setHighlight(true));
      dispatch(certificationActions.setIsHighlighted(false));
    }
  }, [isScroll, currentType]);

  useEffect(() => {
    if (!inGlobalSearch && !globalSearchContentLoaded) {
      dispatch(globalSearchContentActions.globalSearchContent());
    }
  }, [dispatch, globalSearchContentLoaded, inGlobalSearch]);

  useEffect(() => {
    if (!isMidWidth && !inSmartDrawer) {
      scrollHandlerToggleClass('.sub-container-document-hub', 'sticky-header-document', true);
    }
    return () => {
      if (!window.location.pathname.includes('/documents')) {
        if (!inSmartDrawer) {
          dispatch(actions.reset());
        } else {
          dispatch(actions.resetSelectedDocuments(inSmartDrawer));
        }
      }
    };
  }, [dispatch, inSmartDrawer, isMidWidth]);

  const fetchMore = (type: DocHubCurrentViewType) => {
    if ((type === 'folder' || type === 'both') && !entitiesLoading) {
      dispatch(actions.getFolders({
        offset: entities.length ?? 0,
        limit: 20,
        sortingType: docHubSort,
        timezone,
        ...searchTerm?.length && { searchTerm },
        uploadedByMe,
        selectedDocuments: selectedDocumentsString,
        unSelectedDocuments: unSelectedDocumentsString,
        selectedFolders: selectedFoldersString,
        unSelectedFolders: unSelectedFoldersString,
        isSap: inSmartDrawer,
        isSelectAll,
      }));
    } else if (type === 'document' && !entitiesLoading) {
      if (!entitiesLoading && !inGlobalSearch && currentFolder?.id) {
        dispatch(actions.getDocuments({
          folderId: currentFolder?.id,
          folderName: currentFolder.name,
          ...(inSmartDrawer && { isSap: true }),
          offset: showSelected ? sapSelectedDocOffset : entities?.length,
          ...showSelected && { showSelected },
          sortingType: docHubSort,
          limit: 20,
          timezone,
          ...searchTerm?.length && { searchTerm },
          uploadedByMe,
          isSelectAll,
          selectedDocuments: selectedDocumentsString,
          unSelectedDocuments: unSelectedDocumentsString,
          selectedFolders: selectedFoldersString,
          unSelectedFolders: unSelectedFoldersString,
        }));
      }
    }
  };

  useEffect(() => {
    if (!entitiesLoading && !inGlobalSearch) {
      if (currentFolder?.id && currentView === 'document') {
        dispatch(actions.getDocuments({
          folderId: currentFolder.id,
          offset: 0,
          sortingType: docHubSort,
          timezone,
          ...searchTerm?.length && { searchTerm },
          uploadedByMe,
          isSelectAll,
          selectedDocuments: selectedDocumentsString,
          unSelectedDocuments: unSelectedDocumentsString,
          selectedFolders: selectedFoldersString,
          unSelectedFolders: unSelectedFoldersString,
        }));
      } else if (currentView === 'folder' || currentView === 'both') {
        dispatch(actions.getFolders({
          offset: 0,
          limit: 20,
          sortingType: docHubSort,
          timezone,
          ...searchTerm?.length && { searchTerm },
          uploadedByMe,
          selectedDocuments: selectedDocumentsString,
          unSelectedDocuments: unSelectedDocumentsString,
          selectedFolders: selectedFoldersString,
          unSelectedFolders: unSelectedFoldersString,
          isSap: inSmartDrawer,
          isSelectAll,
        }));
      }
    }
  }, [uploadedByMe]);

  const onDownloadClick = (link: string) => {
    if (link) {
      dispatch(actions.downloadDocument(link));
    }
  };

  useEffect(() => {
    if (uploadDocumentStatus && renameData?.fileName !== '') {
      dispatch(actions.renameDocument({
        fileName: renameData?.fileName,
        id: renameData.id,
        timezone,
      }));
      dispatch(actions.setRenameData({
        fileName: '',
        id: 0,
        extension: '',
      }));
      dispatch(actions.setRenameId(0));
      dispatch(flurryActions.callFlurryEvent(valueToObject('documentHub_file_edit_confirms_clicked', 0, {
        user_type: isAdmin ? 'admin' : 'member',
        document_id: renameData.id,
        host,
      })));
      dispatch(actions.setError(false));
      dispatch(actions.setUploadDocumentStatus({ filenameAllowed: false }));
    } else if (renameData?.fileName !== '' && !ValidateLoading) {
      dispatch(actions.setError(!uploadDocumentStatus));
    }
  }, [uploadDocumentStatus, renameData, ValidateLoading]);

  useEffect(() => {
    if (globalSearchContentLoaded
      && !entities?.length) {
      if ((!showDocumentHub || !isEnterprise) && !inGlobalSearch) {
        navigate('/');
      } else {
        fetchMore(currentView);
      }
    }
  }, [docHubSort, searchTerm, currentView, globalSearchContentLoaded]);

  useEffect(() => () => {
    if (saveUrlV2 !== window.location.href) {
      chatActions.setSaveUrl('');
      chatActions.setSaveProfileName('');
    }
  }, []);

  useEffect(() => {
    if (!entitiesEnded && entities?.length < 9 && entitiesLoaded && !inSmartDrawer) {
      fetchMore(currentView);
    }
  }, [entities]);

  useEffect(() => {
    if (downloadUrl?.length) {
      const newWin = window.open(downloadUrl, '_blank');
      if (newWin) {
        dispatch(flurryActions.setNotification({
          message: DOCUMENT_DOWNLOAD_SUCCESS,
          proTip: false,
          rightPlacement: false,
          groupId: 0,
          classnameFlag: true,
        }));
      } else {
        dispatch(flurryActions.setNotification({
          message: DOCUMENT_DOWNLOAD_FAIL,
          proTip: false,
          rightPlacement: false,
          groupId: 0,
          classnameFlag: false,
        }));
      }
      dispatch(actions.documentDownloaded());
    }
  }, [downloadUrl]);

  const onOkClick = () => {
    if (currentFolder?.id) {
      if (deleteId > 0) {
        dispatch(actions.deleteFolder({
          selectedDocuments: deleteId.toString(),
          unSelectedDocuments: '',
          selectedFolders: '',
          unSelectedFolders: '',
          searchTerm: '',
          isSelectAll: false,
          uploadedByMe: false,
          folderId: currentFolder?.id,
        }));
      } else {
        dispatch(actions.deleteFolder({
          selectedDocuments: selectedDocumentsString,
          unSelectedDocuments: unSelectedDocumentsString,
          selectedFolders: selectedFoldersString,
          unSelectedFolders: unSelectedFoldersString,
          searchTerm,
          isSelectAll,
          uploadedByMe,
          folderId: currentFolder?.id,
        }));
      }
    } else if (deleteId > 0) {
      dispatch(actions.deleteFolder({
        selectedDocuments: '',
        unSelectedDocuments: '',
        selectedFolders: deleteId.toString(),
        unSelectedFolders: '',
        searchTerm: '',
        isSelectAll: false,
        uploadedByMe: false,
      }));
    } else {
      dispatch(actions.deleteFolder({
        selectedDocuments: selectedDocumentsString,
        unSelectedDocuments: unSelectedDocumentsString,
        selectedFolders: selectedFoldersString,
        unSelectedFolders: unSelectedFoldersString,
        searchTerm,
        isSelectAll,
        uploadedByMe,
      }));
    }

    dispatch(actions.setDeletePopupVisible(false));
    dispatch(actions.setDeleteId(-1));
    dispatch(actions.setRenameData({
      fileName: '',
      id: 0,
      extension: '',
    }));
    dispatch(actions.setUploadDocumentStatus({ filenameAllowed: false }));
    dispatch(actions.toggleDocumentPopover(0));
    dispatch(flurryActions.callFlurryEvent(valueToObject(`documentHub_${deletePopupType === 'document' ? 'file' : 'folder'}_delete_confirmed_clicked`, 0, {
      user_type: isAdmin ? 'admin' : 'member',
      document_id: deleteId,
      host,
    })));
  };

  const onSortClick = (type: string) => {
    if (!entitiesLoading) {
      dispatch(actions.toggleSorting(type));
    }
  };

  useEffect(() => {
    if (sortFlurry && !inSmartDrawer) {
      dispatch(flurryActions.callFlurryEvent(valueToObject('documentHub_sorting_updated', 0, {
        sorting_type: sortFlurry,
        host,
      })));
    }
  }, [sortFlurry]);

  useEffect(() => {
    const node = document.querySelector('body');
    return drawerOpenForDoc ? node?.classList.add('body-drawer-alerts-toggle') : node?.classList.remove('body-drawer-alerts-toggle');
  }, [drawerOpenForDoc]);

  const onCancelClick = () => {
    dispatch(actions.setDeletePopupVisible(false));
    dispatch(actions.setDeleteId(-1));
    dispatch(actions.toggleDocumentPopover(0));
    dispatch(actions.setRenameData({
      fileName: '',
      id: 0,
      extension: '',
    }));
    dispatch(actions.setUploadDocumentStatus({ filenameAllowed: false }));
  };

  const onClickOk = () => {
    dispatch(flurryActions.callFlurryEvent(valueToObject('documentHub_upload_cancel_confirm', 0, {
      host,
    })));
    dispatch(actions.setCancelPopup({
      popupText: '',
      okButtonText: '',
      cancelButtonText: '',
    }));
    if (uploadCancelled) {
      dispatch(flurryActions.setNotification({
        message: CANCEL_FAILED_TOASTER,
        proTip: false,
        rightPlacement: false,
        groupId: 0,
        classnameFlag: false,
      }));
    } else {
      dispatch(actions.cancelUpload());
      // dispatch(actions.setDrawerOpen(false));
    }
  };

  const onClickCancel = () => {
    dispatch(actions.setCancelPopup({
      popupText: '',
      okButtonText: '',
      cancelButtonText: '',
    }));
  };

  const toggle = (flag: boolean) => {
    setOpenCreateModal(flag);
  };

  useEffect(() => {
    if (companyId) {
      dispatch(certificationActions.aiCertificationAction({
        type: 'document_hub_panel',
        source: 'doc_gilroy',
        data: aiCertificationData,
      }));
    }
  }, [companyId]);

  useEffect(() => {
    if (isCompletionPopupOpen) {
      dispatch(actions.setDrawerOpen(false));
    }
  }, [isCompletionPopupOpen]);

  const createDocumentsRoute = () => {
    dispatch(flurryActions.callFlurryEvent(
      valueToObject('searchPage_documents_see_all_clicked', 0, {
        host,
      }),
    ));
    window.scrollTo(0, 0);
    return navigate(`${pathname}?query=${searchQuery}&extend=document`, { state: { enableBackButton: true, previousPath } });
  };

  const navigateToSearchResult = () => {
    const path = `${SEARCH_ROUTE}${searchQuery}`;
    navigate(path, {
      state: isDetailedSearch ? { enableBackButton: true, previousPath } : { previousPath },
    });
  };


  return (
    <Wrapper className={classNames({
      ShowBackBtnStyle: saveProfileNameV2?.length,
      documentHubInSAP: inSmartDrawer,
      globalSearchFlag: inGlobalSearch,
    })}
    >
      {inSmartDrawer ? (!showUploadDocument ? ( // where
        <Tooltip
          placement="top"
          getPopupContainer={(e: HTMLElement) => e}
          className="triggers-bullet-tooltip"
          color="#fff"
          title="The subscription admin has not granted you access to upload new files."
          zIndex={1}
          arrow={false}
        >
          <div>
            <span
              role="button"
              tabIndex={-1}
              className={classNames('uploadBtn', { disabled: !showUploadDocument })}
              onClick={handleUploadClick}
              onKeyPress={handleUploadClick}
            >
              Upload
              <UploadDocumentIcon />
            </span>
          </div>
        </Tooltip>
      ) : (
        <span
          role="button"
          tabIndex={-1}
          className={classNames('uploadBtn', { disabled: !showUploadDocument })}
          onClick={handleUploadClick}
          onKeyPress={handleUploadClick}
        >
          Upload
          <UploadDocumentIcon />
        </span>
      )
      ) : !inGlobalSearch && (
        <NavBarPrimary>
          <div className="left-side-wrap smMob-NavBar-Wrapper no-overflow-on-header">
            <DocumentSvg color={primaryHeadingColor} />
            <Divider type="vertical" />
            <h1 className="heading">Document Hub</h1>
          </div>
          <div className="right-side-wrap">
            <GlobalSearch
              highlighted
              iconMode={isTab}
            />
            <DrawerAlerts />
            <AccountPopOver />
          </div>
        </NavBarPrimary>
      )}
      {inGlobalSearch && !globalSearchloading ? (
        <HeadingWithShowAll
          inGlobalSearch={inGlobalSearch}
          isShowAllHidden={isDetailedSearch ? true
            : documentsCount && documentsCount?.length <= slicerNumber}
          leftHeading={(
            <SectionHeading customClassName="global-search-heading">{`${heading} (${count})`}</SectionHeading>)}
          onClick={createDocumentsRoute}
          onSeelessClick={navigateToSearchResult}
          isDetailedSearch={isDetailedSearch}
        />
      ) : null}
      {chatbotAllowed && allowGlobalGilroy && !inSmartDrawer && !inGlobalSearch ? (
        <Gilroy gilroyStates={gilroyStates} gilroyActions={gilroyActions} />
      ) : null}
      <div className={classNames({
        container: !inGlobalSearch,
        searchDocumentContainer: inGlobalSearch,
      })}
      >
        {saveProfileNameV2?.length && !inSmartDrawer ? (
          <BackActionDiv className="back-action-div">
            <BackIcon onClick={() => {
              if (!saveProfileNameV2.includes(SMART_REDIRECTION_TEXT) && allowGlobalGilroy) {
                dispatch(UiAction.isShowGilroyGlobalToggle(true));
                dispatch(companyActions.setAccountPlanSlideIndex(0));
              } else if (saveProfileNameV2.includes(SMART_REDIRECTION_TEXT)) {
                dispatch(flurryActions.callFlurryEvent(
                  valueToObject(`filesUploaded_${uploadedDocCount}_accountPlan`, startTime, {}),
                ));
              }
              navigate(-1);
            }}
            />
            <Divider type="vertical" />
            <span className="back-action-text text-truncate">
              Return to
              {' '}
              {saveProfileNameV2}
            </span>
          </BackActionDiv>
        ) : null}
        <div className="sub-container-document-hub" id="certification-doc-hub">
          {!inGlobalSearch ? (
            <DocumentHubHeader
              loading={entitiesLoading}
              loaded={entitiesLoaded}
              inSmartDrawer={inSmartDrawer}
            />
          ) : null}
          {entitiesLoaded && !entities.length && !uploadedDocuments.length
            && !inGlobalSearch
            ? <EmptyStateDocumentHub isSearch={!!searchTerm?.length || currentView === 'both'} emptyDocHub={false} /> : null}
          {
            entitiesLoading || entities.length
              || uploadedDocuments.length || (searchDocumentHubVisible) || inSmartDrawer
              ? (
                <DocumentHubTable
                  entities={inGlobalSearch ? documentsToDisplay
                    : inGlobalSearch ? documentsToDisplay
                      : uploadedDocuments.length
                        ? [...uploadedDocuments, ...entities] : entities}
                  entitiesLoading={entitiesLoading}
                  entitiesEnded={entitiesEnded}
                  fetchMore={fetchMore}
                  onDownload={onDownloadClick}
                  sort={docHubSort}
                  onSort={onSortClick}
                  drawerOpen={drawerOpenForDoc}
                  setDrawerOpenForDoc={setDrawerOpenForDoc}
                  previewDocument={previewDocument}
                  hideCheckbox={!!saveProfileNameV2?.length}
                  inSmartDrawer={inSmartDrawer}
                  inGlobalSearch={inGlobalSearch}
                  currentView={currentView}
                  isFolderSelected={isFolderSelected}
                  setDeletePopupVisible={(flag) => dispatch(actions.setDeletePopupVisible(flag))}
                />
              ) : null
          }
        </div>

        <DrawerUploadDocument
          inSmartDrawer={inSmartDrawer}
          visible={drawerOpen}
          state={drawerState}
          handleDrawerClose={toggleDrawer}
          handleStateChange={handleDrawerState}
          uploading={batchUploading}
          uploadCancelled={uploadCancelled}
          isNextUpload={!!nextUploadDocuments?.length}
        />
        <Modal
          open={deletePopupVisible}
          onOk={onOkClick}
          onCancel={onCancelClick}
          centered
          cancelText="Cancel"
          okText="Delete"
          width={isTab ? '340px' : '528px'}
          className="delete-document-popup"
        >
          <img src={sadGilroyFace} alt="sad-gilroy" className="gilroy-white-svg" />
          <span className="clear-text-modal">
            {deletePopupText()}
          </span>
        </Modal>
      </div>
      <DocumentUploadCancelPopup
        showPopup={!!popupText?.length}
        popupText={popupText}
        okText={okButtonText}
        cancelText={cancelButtonText}
        onClickOk={onClickOk}
        onClickCancel={onClickCancel}
      />
      {
        inSmartDrawer ? null : (
          <DrawerPeopleGroup
            openNewCreate={openCreateModal}
            setOpenNew={toggle}
            showNew={showNew}
            toggleShowNew={(bool: boolean) => setShowNew(bool)}
            disableDrop
            noButton
          />
        )
      }
      {inGlobalSearch && isDocumentSearchPaginated && <DocumentHubTableSkeleton />}
      <AddItemToFolderModal
        uploadedByMe={uploadedByMe}
        isSelectAll={isSelectAll}
        selectedDocuments={selectedDocumentsString}
        unSelectedDocuments={unSelectedDocumentsString}
        selectedFolders={selectedFoldersString}
        unSelectedFolders={unSelectedFoldersString}
        searchTerm={searchTerm}
        selectedDocumentsCount={selectedDocumentsCount}
        currentFolderId={currentFolder?.id || 0}
      />
    </Wrapper>
  );
};
DocumentHub.defaultProps = defaultProps;
export default DocumentHub;